import axios from './axios'
import { Associated, Careprovider } from '@/../../EshJSLib/models/patient'

export async function saveDoctorsAssociated(params: Associated) {
    let response = {} as any;
    const json = JSON.stringify(params);
    response = await axios.post(`/api/dottori`, json).catch((error) => {
        throw error
    })
    return response;
}

export async function getAscDoctors(id: Number) {
    const response = await axios.get(`/api/getAscDoctors/${id}`);
    return response.data.data as Associated[];
}

export async function cppConsent(id: Number) {
    let response = {} as any;
    response = await axios.get(`/api/cppConsent/${id}`).catch((error) => {
        throw error
    })
    return response.data;
}

export async function addConsent(id: Number) {
    let response = {} as any;
    response = await axios.get(`/api/acceptConsent/${id}`).catch((error) => {
        throw error
    })
    return response.data;
}

export async function toggleDoctor(params: string) {
    const response = await axios.post(`/api/toggleDoctor`, params);
}

export async function getNAdoctors(id: Number) {
    const response = await axios.get(`/api/getNAdoctors/${id}`);
    return response.data.data as Careprovider[];
}

export async function updateConfidentialitaandVisibilita(params: Associated) {
    const response = await axios.post(`/api/associatedCareProviders`,params);
    return response.data;
}